<template>
    <div class="h-full w-full flex flex-col bg-gradient-to-br from-gray-100 to-blue-50">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">

                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/partnerships" class="opacity-50 hover:opacity-100">Partnerships</router-link>
                        <span class="mx-2">/</span>
                        <span>Adjunct Faculty</span>
                    </div>
                    <div class="font-bold">Adjunct Faculty</div>
                </div>

                <div class="mt-4 flex justify-end items-center">
                    <div v-if="isExportExcel"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg hover:text-ternary text-white">
                        <base-spinner-with-text class-list="w-4 h-4" text=""
                            text-class-list="text-white"></base-spinner-with-text>
                        <span class="text-xs">Exporting Excel</span>
                    </div>
                    <div v-else @click="generateReport"
                        class="w-44 flex items-center justify-center hover:bg-purple-50 bg-ternary border-ternary hover:border-ternary border px-4 py-2 rounded-lg cursor-pointer hover:text-ternary text-white">
                        <font-awesome-icon :icon="['fas', 'file-excel']" />
                        <span class="text-xs ml-2">Export Excel</span>
                    </div>
                </div>

                <section class="mt-4 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex justify-between flex-wrap">
                        <h1 class="text-base md:text-lg font-semibold mb-4">Adjunct Faculty List</h1>
                        <div class="flex justify-start items-center flex-wrap">
                            <div
                                class="w-full sm:w-auto ml-0 sm:ml-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                <div class="text-sm mr-2">Entity:</div>
                                <select v-model="filterByEntity" class="outline-none text-sm flex-grow">
                                    <option value="">All</option>
                                    <option value="FCHS">FCHS</option>
                                    <option value="ADPOLY">ADPOLY</option>
                                </select>
                            </div>
                            <div class="flex justify-start items-center flex-wrap">
                                <div
                                    class="w-full sm:w-auto ml-0 sm:ml-8 mb-4 border rounded-lg px-4 h-8 flex items-center">
                                    <div class="text-sm mr-2">Program:</div>
                                    <select v-model="filterByProgram" class="outline-none text-sm flex-grow">
                                        <option value="">All</option>
                                        <option :value="program.name" v-for="(program, index) in filteredPrograms"
                                            :key="index">{{ program.name }}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="w-full sm:w-auto ml-0 sm:ml-8 mb-4">
                                <search @on-search="onSearch" class-list="px-4 h-8"></search>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col" v-if="$apollo.queries.adjunct_faculties.loading">
                        <table-shimmer
                            :titleHeaders="['#', 'Adjunct Faculty', 'CV', 'Mobile Number', 'Nationality', 'Area of specialization', 'Registered At', 'Actions',]"
                            :rows="first"></table-shimmer>
                    </div>
                    <div v-else-if="!$apollo.queries.adjunct_faculties.loading && !hasItems"
                        class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No results found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex flex-col overflow-x-auto">
                            <div class="inline-block min-w-full py-2">
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-left text-sm font-light">
                                        <thead class="border-b font-medium dark:border-neutral-500">
                                            <tr>
                                                <th scope="col" class="px-6 py-2 text-gray-400 w-8">#</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Adjunct Faculty</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">CV</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Mobile Number</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Nationality</th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">
                                                    <div class="text-center">Area of specialization</div>
                                                    <div class="flex flex-row flex-wrap">
                                                        <div class="w-1/2 flex justify-center">FCHS</div>
                                                        <div class="w-1/2 flex justify-center">ADPOLY</div>
                                                    </div>
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400 whitespace-nowrap">
                                                    Registered At</th>
                                                <th scope="col"
                                                    class="px-6 py-2 text-gray-400 whitespace-nowrap text-center">Status
                                                </th>
                                                <th scope="col" class="px-6 py-2 text-gray-400">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in items" :key="index"
                                                class="border-b border-dashed dark:border-neutral-500">
                                                <td class="whitespace-nowrap px-6 py-2 font-medium">{{
                                                    paginatorInfo.firstItem + index }}</td>
                                                <td class="whitespace-nowrap px-6 py-2">
                                                    <div class="flex items-center">
                                                        <div class="flex-shrink-0 mr-3">
                                                            <img class="h-12 w-12 rounded-lg object-cover"
                                                                :src="getSrc(item.profile_picture_url)"
                                                                alt="Profile Picture">
                                                        </div>
                                                        <div class="flex-grow flex flex-col mr-4">
                                                            <h1 class="text-sm font-semibold flex items-center">
                                                                <span @click.stop="viewItem(item)"
                                                                    class="text-heading hover:text-blue-600 hover:underline cursor-pointer">{{
                                                                        item.full_name }}</span>
                                                            </h1>
                                                            <p class="text-xs text-gray-400">{{ item.email }}</p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-2">
                                                    <div v-if="item.cv_url == null || item.cv_url == ''">
                                                        Not uploaded yet</div>
                                                    <div v-else class="w-14">
                                                        <a target="_blank" :href="getCvUrl(item.cv_url)"
                                                            class="text-blue-600 hover:underline">View CV</a>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-2">{{ item.mobile_number }}</td>
                                                <td class="px-6 py-2">{{ item.current_nationality }}</td>
                                                <td class="px-6 py-2">
                                                    <div class="flex flex-row flex-wrap">
                                                        <div class="w-1/2 pr-1 break-all">{{
                                                            item.fchs_area_of_specializations }}</div>
                                                        <div class="w-1/2 pl-1 break-all">{{
                                                            item.adpoly_area_of_specializations }}</div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-2 text-center whitespace-nowrap">{{
                                                    getFormattedDate(item.created_at) }}</td>
                                                <td class="px-6 py-2 text-center whitespace-nowrap"
                                                    v-html="getStatus(item.status, item.adjunct_faculty_approval)"></td>
                                                <td class="px-6 py-2">
                                                    <div class="flex">
                                                        <div v-if="hasPermission('adjunct-faculty-show')"
                                                            @click.stop="viewItem(item)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer">
                                                            <icon-eye
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-eye>
                                                        </div>
                                                        <div v-if="hasPermission('adjunct-faculty-edit') && isShowApproveReject(item.status)"
                                                            @click.stop="approveItem(item.token, true)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer ml-2">
                                                            <icon-approve
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-approve>
                                                        </div>
                                                        <div v-if="hasPermission('adjunct-faculty-edit') && isShowApproveReject(item.status)"
                                                            @click.stop="rejectItem(item.token)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer ml-2">
                                                            <icon-reject
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-reject>
                                                        </div>
                                                        <div v-if="hasPermission('adjunct-faculty-delete') && isShowDelete(item.status)"
                                                            @click.stop="deleteItem(item.token)"
                                                            class="bg-gray-100 hover:bg-blue-50 w-8 h-8 flex justify-center items-center rounded-lg group cursor-pointer ml-2">
                                                            <icon-trash
                                                                class="w-4 h-4 transform group-hover:text-purple-pink group-hover:scale-110 hover:scale-110"></icon-trash>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="mt-4">
                            <pagination :paginatorInfo="paginatorInfo" :setPage="setPage"></pagination>
                        </div>
                    </div>

                    <transition name="fade" mode="out-in">
                        <base-modal v-if="showAddNote" :title="`Add Your Note`" @close="closeAddNote">
                            <div class="flex flex-col">
                                <div class="flex flex-col" :class="{ invalid: !note.isValid }">
                                    <label for="note" class="px-8 mt-4 text-sm ml-1">Note</label>
                                    <div class="h-32 px-8 rounded-xl mt-2">
                                        <textarea v-model.trim="note.val" @blur="clearValidity('note')" id="note"
                                            :class="note.isValid ? '' : 'border-red-600'"
                                            class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
                                    </div>
                                    <transition name="form-fade" mode="out-in">
                                        <p v-if="!note.isValid" class="px-8 h-4 text-xs text-red-600 ml-1">
                                            {{ note.msg }}
                                        </p>
                                    </transition>
                                </div>
                                <div class="flex justify-end mt-4 mr-8">
                                    <div @click.stop="addNoteOk"
                                        class="border-2 font-medium border-ternary text-white hover:text-ternary bg-ternary hover:bg-white rounded-lg px-5 py-2 uppercase text-sm cursor-pointer">
                                        OK</div>
                                </div>
                            </div>
                        </base-modal>
                    </transition>

                    <transition name="fade" mode="out-in">
                        <base-full-modal v-if="isViewItem" :title="`View Adjunct Faculty - ${selectedItem.full_name}`"
                            @close="closeModal">
                            <view-post class="text-left p-8" :item="selectedItem" @close="closeModal"></view-post>
                        </base-full-modal>
                    </transition>

                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isLoading || isExportExcel">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>

<script>
import IconEye from "../../components/icons/IconEye.vue";
import IconApprove from "../../components/icons/IconApprove.vue";
import IconReject from "../../components/icons/IconReject.vue";
import IconTrash from "../../components/icons/IconTrash.vue";
import gql from 'graphql-tag';
import Pagination from "../../components/shared/pagination.vue";
import TableShimmer from '../../components/shared/TableShimmer.vue';
import ViewPost from "./view.vue";
import { formattedDate } from "../../helpers/utils";
import xlsx from "xlsx/dist/xlsx.full.min.js";
import Search from "../../components/shared/search.vue";
export default {
    name: "adjunct-faculty-index",
    components: {
        IconEye,
        IconApprove,
        IconReject,
        IconTrash,
        Pagination,
        TableShimmer,
        ViewPost,
        Search,
    },
    data() {
        return {
            adjunct_faculties: [],
            first: 10,
            page: 1,
            isViewItem: false,
            selectedItem: null,
            isLoading: false,
            note: {
                val: "",
                isValid: true,
                msg: "",
            },
            showAddNote: false,
            selectedToken: null,
            isExportExcel: false,
            generatedReport: [],
            filterByEntity: "",
            filterByProgram: "",
            programs: [
                {
                    entity: "FCHS",
                    name: "Nursing",
                },
                {
                    entity: "FCHS",
                    name: "Pharmacy",
                },
                {
                    entity: "FCHS",
                    name: "Physiotherapy",
                },
                {
                    entity: "FCHS",
                    name: "Emergency Health",
                },
                {
                    entity: "FCHS",
                    name: "Radiography and Medical Imaging (RMI)",
                },
                {
                    entity: "FCHS",
                    name: "Psychology",
                },
                {
                    entity: "FCHS",
                    name: "General requirements",
                },
                {
                    entity: "FCHS",
                    name: "Midwifery",
                },
                {
                    entity: "ADPOLY",
                    name: "EMET",
                },
                {
                    entity: "ADPOLY",
                    name: "Petroleum Engineering",
                },
                {
                    entity: "ADPOLY",
                    name: "Information Security",
                },
                {
                    entity: "ADPOLY",
                    name: "Meteorology",
                },
                {
                    entity: "ADPOLY",
                    name: "Aviation Mechanical Technology",
                },
                {
                    entity: "ADPOLY",
                    name: "Aviation Engineering Technology",
                },
                {
                    entity: "ADPOLY",
                    name: "Academic Support",
                },
            ],
            searchText: "",
        };
    },
    watch: {
        searchText() {
            this.page = 1;
        },
        adjunct_faculties(newVal) {
            if (newVal.error) {
                if (newVal.error_code == 403) {
                    this.$router.replace('/no-permission');
                } else if (newVal.error_code == 401) {
                    this.$router.replace('/');
                } else {
                    alert(newVal.message);
                    this.$router.replace('/');
                }
            }
        },
        filterByEntity() {
            this.filterByProgram = "";
            this.page = 1;
        },
        filterByProgram() {
            this.page = 1;
        },
    },
    computed: {
        items() {
            return this.adjunct_faculties.data;
        },
        hasItems() {
            if (this.items && this.items.length > 0) {
                return true;
            } else {
                return false;
            }
        },
        paginatorInfo() {
            return this.adjunct_faculties.paginatorInfo;
        },
        role() {
            return this.$store.getters.role;
        },
        filteredPrograms() {
            if (this.filterByEntity === '') {
                return this.programs;
            } else {
                return this.programs.filter(program => program.entity === this.filterByEntity);
            }
        },
    },
    apollo: {
        adjunct_faculties() {
            return {
                query: gql`query GetAllAdjunctFaculties($first: Int!, $page: Int!, $entity: String, $program: String, $search: String) {
                    adjunct_faculties(first: $first, page: $page, entity: $entity, program: $program, search: $search) {
                        error
                        error_code
                        message
                        data {
                            token
                            full_name
                            previous_name
                            current_nationality
                            previous_nationality
                            mobile_number
                            date_of_birth
                            email
                            fchs_area_of_specializations
                            adpoly_area_of_specializations
                            profile_picture_url
                            cv_url
                            status
                            created_at
                            educational_qualifications {
                              qualification
                              university_or_institute
                              country
                              completion_year
                              mode_of_study
                              equivalancy_status
                            }
                            professional_certificates {
                              certificate
                              completion_year
                            }
                            current_employments {
                              job_title
                              employer
                              city
                              years_of_experience
                            }
                            availability_to_teach {
                              day
                              am_value
                              pm_value
                            }
                            adjunct_faculty_approval {
                                note
                                user {
                                    name
                                    email
                                }
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables() {
                    return {
                        first: this.first,
                        page: this.page,
                        entity: this.filterByEntity,
                        program: this.filterByProgram,
                        search: this.searchText,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        onSearch(searchText) {
            this.searchText = searchText;
        },
        setPage(page) {
            this.page = page;
        },
        getSrc(url) {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },
        closeModal() {
            this.isViewItem = false;
            this.selectedItem = null;
        },
        showToast(message = '') {
            this.$apollo.queries.adjunct_faculties.refetch();
            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'success',
                title: message
            })
            this.closeModal();
        },
        async deleteItem(token) {
            let error_msg = null;
            let success_msg = null;
            this.$swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {

                    const DELETE_MUTATION = gql`
                        mutation DeleteAdjunctFaculty($token: String!) {
                            deleteAdjunctFaculty(token: $token) {
                                error
                                message
                            }
                        }
                    `;

                    try {
                        await this.$apollo.mutate({
                            mutation: DELETE_MUTATION,
                            variables: {
                                token: token,
                            }
                        }).then((data) => {
                            if (data.data.deleteAdjunctFaculty.error) {
                                error_msg = data.data.deleteAdjunctFaculty.message;
                            } else {
                                success_msg = data.data.deleteAdjunctFaculty.message;
                            }
                        }).catch((error) => {
                            error_msg = error.message;
                        })

                    } catch (error) {
                        error_msg = error.message || "Please try again.";
                    }

                    if (error_msg === null) {
                        this.showToast(success_msg);
                    } else {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: error_msg,
                        }).then((result) => {
                            if (result.value || result.dismiss) {
                                error_msg = null
                            }
                        })
                    }

                }
            })
        },
        hasPermission(crudName) {
            if (this.role == 'superadmin') {
                return true;
            } else {
                const permissions = this.$store.getters.permissions;
                const permissionsArray = permissions.split(",");
                if (permissionsArray.includes(crudName)) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        viewItem(item) {
            this.selectedItem = item;
            this.isViewItem = true;
        },
        approveItem(token) {
            this.approveOrRejectAdjunctFaculty(token, true);
        },
        rejectItem(token) {
            this.selectedToken = token;
            this.showAddNote = true;
        },
        closeAddNote() {
            this.showAddNote = false;
            this.note.val = "";
            this.note.isValid = true;
            this.note.msg = "";
            this.selectedToken = null;
        },
        addNoteOk() {
            if (this.note.val === "") {
                this.note.isValid = false;
                this.note.msg = "You must enter a note.";
            } else {
                this.showAddNote = false;
                this.approveOrRejectAdjunctFaculty(this.selectedToken, false);
            }
        },
        clearValidity(input) {
            this[input].isValid = true;
            this[input].msg = "";
        },
        async approveOrRejectAdjunctFaculty(token, status) {

            this.isLoading = true;

            const APPROVE_OR_REJECT_MUTATION = gql`
                mutation ApproveOrRejectAdjunctFaculty($token: String!, $status: Boolean!, $note: String) {
                    approveOrRejectAdjunctFaculty(token: $token, status: $status, note: $note) {
                        error
                        message
                    }
                }
            `;

            let error_msg = null;
            let success_msg = null;

            try {
                await this.$apollo.mutate({
                    mutation: APPROVE_OR_REJECT_MUTATION,
                    variables: {
                        token: token,
                        status: status,
                        note: this.note.val,
                    }
                }).then((data) => {
                    if (data.data.approveOrRejectAdjunctFaculty.error) {
                        error_msg = data.data.approveOrRejectAdjunctFaculty.message;
                    } else {
                        success_msg = data.data.approveOrRejectAdjunctFaculty.message;
                    }
                }).catch((error) => {
                    console.error(error)
                })
            } catch (error) {
                error_msg = error.message || "Failed to authenticate, try later.";
            }

            if (error_msg === null) {
                this.showToast(success_msg);
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error_msg,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        error_msg = null
                    }
                })
            }

            this.note = "";
            this.isLoading = false;

        },
        getFormattedDate(date) {
            return formattedDate(date);
        },
        getStatus(status, approvalUser) {
            if (status === null) {
                return "";
            } else if (status === true) {
                return `<div class="flex flex-col items-center"><div class="text-green-600">Approved by</div><div>${approvalUser.user.name}</div><div>(${approvalUser.user.email})</div></div>`;
            } else {
                return `<div class="flex flex-col items-center"><div class="text-red-600">Rejected by</div><div>${approvalUser.user.name}</div><div>(${approvalUser.user.email})</div></div>`;
            }
        },
        isShowApproveReject(status) {
            if (this.role == 'admin' || this.role == 'superadmin') {
                if (status === null) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        isShowDelete(status) {
            if (status === true) {
                return false;
            } else {
                return true;
            }
        },
        async generateReport() {
            this.isExportExcel = true;

            try {
                const { data } = await this.$apollo.query({
                    query: gql`query GenerateAdjunctFacultyReport($entity: String, $program: String) {
                        generateAdjunctFacultyReport(entity: $entity, program: $program) {
                            error
                            error_code
                            message
                            data {
                                full_name
                                previous_name
                                current_nationality
                                previous_nationality
                                mobile_number
                                date_of_birth
                                email
                                fchs_area_of_specializations
                                adpoly_area_of_specializations
                                created_at
                                current_employments {
                                    job_title
                                    employer
                                    city
                                    years_of_experience
                                }
                            }
                        }
                    }`,
                    variables: {
                        entity: this.filterByEntity,
                        program: this.filterByProgram,
                    },
                    fetchPolicy: 'network-only'
                });

                this.generatedReport = data.generateAdjunctFacultyReport.data.map(obj => {
                    return {
                        full_name: obj.full_name,
                        previous_name: obj.previous_name,
                        current_nationality: obj.current_nationality,
                        previous_nationality: obj.previous_nationality,
                        mobile_number: obj.mobile_number,
                        date_of_birth: this.getFormattedDate(obj.date_of_birth),
                        email: obj.email,
                        employer: obj.current_employments.length > 0 ? obj.current_employments[0].employer : "",
                        job_title: obj.current_employments.length > 0 ? obj.current_employments[0].job_title : "",
                        city: obj.current_employments.length > 0 ? obj.current_employments[0].city : "",
                        years_of_experience: obj.current_employments.length > 0 ? obj.current_employments[0].years_of_experience : "",
                        fchs_area_of_specializations: obj.fchs_area_of_specializations,
                        adpoly_area_of_specializations: obj.adpoly_area_of_specializations,
                        created_at: this.getFormattedDate(obj.created_at),
                    }
                });

                this.exportExcel('Adjunct_Faculty_List');

            } catch (error) {
                console.log(error.message);
            }

            this.isExportExcel = false;
            this.generatedReport = [];
        },
        exportExcel(reportName) {
            const XLSX = xlsx;

            const header = [
                "Fullname",
                "Previous Name",
                "Current Nationality",
                "Previous Nationality",
                "Mobile Number",
                "Date of Birth",
                "Email",
                "Employer",
                "Job Title",
                "City",
                "Years of experience",
                "FCHS area of specializations",
                "ADPOLY area of specializations",
                "Registered At",
            ];

            const worksheet = XLSX.utils.json_to_sheet(this.generatedReport);

            worksheet["A1"] = { v: header[0], t: "s" }
            worksheet["B1"] = { v: header[1], t: "s" }
            worksheet["C1"] = { v: header[2], t: "s" }
            worksheet["D1"] = { v: header[3], t: "s" }
            worksheet["E1"] = { v: header[4], t: "s" }
            worksheet["F1"] = { v: header[5], t: "s" }
            worksheet["G1"] = { v: header[6], t: "s" }
            worksheet["H1"] = { v: header[7], t: "s" }
            worksheet["I1"] = { v: header[8], t: "s" }
            worksheet["J1"] = { v: header[9], t: "s" }
            worksheet["K1"] = { v: header[10], t: "s" }
            worksheet["L1"] = { v: header[11], t: "s" }
            worksheet["M1"] = { v: header[12], t: "s" }
            worksheet["N1"] = { v: header[13], t: "s" }

            worksheet['!cols'] = [
                { width: 40 },
                { width: 40 },
                { width: 30 },
                { width: 30 },
                { width: 20 },
                { width: 20 },
                { width: 40 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 20 },
                { width: 60 },
                { width: 60 },
                { width: 20 },
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            XLSX.writeFile(workbook, `${reportName}.xlsx`);
        },
        getCvUrl(cv_url) {
            let url = "";
            if (cv_url) {
                url = process.env.VUE_APP_PUBLIC_URL + cv_url;
            }
            return url;
        },
    },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.form-fade-enter-active,
.form-fade-leave-active {
    transition: all 0.5s ease;
}

.form-fade-enter-from,
.form-fade-leave-to {
    opacity: 0;
    height: 0px;
}
</style>